import { render, staticRenderFns } from "./CourseCatalog.vue?vue&type=template&id=7bc0ad81&scoped=true"
import script from "./CourseCatalog.vue?vue&type=script&lang=js"
export * from "./CourseCatalog.vue?vue&type=script&lang=js"
import style0 from "./CourseCatalog.vue?vue&type=style&index=0&id=7bc0ad81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc0ad81",
  null
  
)

export default component.exports